export function addToFavorite(eventId, callback) {
    fetch('/api/v1/conference/' + eventId + '/favorite', {
        method: 'POST',
    })
        .then(res => res.json())
        .then(
            (result) => {
                callback(result);
            }
        )
}

export function removeFromFavorite(eventId, callback) {
    fetch('/api/v1/conference/' + eventId + '/favorite', {
        method: 'DELETE',
    })
        .then(res => res.json())
        .then(
            (result) => {
                callback(result);
            }
        )
}

export function checkIn(eventId, callback) {
    fetch('/api/v1/conference/' + eventId + '/checkIn', {
        method: 'POST',
    })
        .then(res => res.json())
        .then(
            (result) => {
                callback(result);
            }
        )
}
